/*
Conditions d'utilisation — l'app est ouverte (MIT) et single-player.
Le contenu factuel est minimal&nbsp;: pas de service hébergé, pas de
contrat, pas de support officiel. Le seul point juridique réellement
utile est la propriété des captures, que l'utilisateur peut récupérer
et déplacer comme il veut.
*/

import { mountInfoScreen, type InfoScreenContent } from './components/InfoScreen'

const kContent: InfoScreenContent = {
	title: "Conditions d'utilisation",
	leadHtml: `
		CanoPaname est un projet personnel distribué gratuitement sous
		licence MIT, sans service hébergé. Ces conditions clarifient ce que
		tu possèdes et ce qui est fourni «&nbsp;tel quel&nbsp;».
	`,
	sections: [
		{
			heading: '👤 Tes captures t\'appartiennent',
			bodyHtml: `
				<p>
					Les captures que tu fais dans CanoPaname — photos, positions,
					timestamps, espèces identifiées, badges débloqués — sont
					ton contenu. Tu en es propriétaire. Tu peux à tout moment&nbsp;:
				</p>
				<ul class="info-list">
					<li>les exporter en ZIP via <em>Profil → Exporter</em>&nbsp;;</li>
					<li>les importer dans l'app Android CanoPaname (format identique)&nbsp;;</li>
					<li>les utiliser, partager, publier comme bon te semble.</li>
				</ul>
				<p>
					CanoPaname ne lit pas tes captures, ne les transmet à
					personne, et n'en revendique aucun droit.
				</p>
			`,
		},
		{
			heading: '📜 Données externes',
			bodyHtml: `
				<p>
					Le dataset des arbres, les résumés Wikipédia et la
					cartographie OpenStreetMap inclus dans l'app conservent leurs
					licences respectives — voir la page <em>À propos</em> pour
					les attributions. Si tu publies ou redistribues une partie
					significative du dataset, l'ODbL t'oblige à mentionner la
					source («&nbsp;© Ville de Paris&nbsp;»).
				</p>
			`,
		},
		{
			heading: '⚠️ Fournie «&nbsp;telle quelle&nbsp;»',
			bodyHtml: `
				<p>
					CanoPaname est fournie sans garantie d'aucune sorte,
					expresse ou implicite, y compris sans limitation les
					garanties de qualité marchande, d'adéquation à un usage
					particulier, ou d'absence de bug. L'auteur ne pourra être
					tenu responsable de pertes de données, de captures
					évincées par un manque de stockage, ou de tout dommage
					découlant de l'utilisation de l'app.
				</p>
				<p class="info-note">
					Pour limiter les pertes&nbsp;: garde l'app en mode
					«&nbsp;Ajoutée à l'écran d'accueil&nbsp;» / installée, et fais
					des exports ZIP réguliers.
				</p>
			`,
		},
		{
			heading: '🚫 Pas de service, pas de support',
			bodyHtml: `
				<p>
					Il n'existe pas de serveur CanoPaname à contacter, pas
					d'engagement de disponibilité, pas de SLA. Les bugs sont
					traités au gré des envies du mainteneur — ouvre une issue
					sur
					<a class="info-link" href="https://github.com/m4xim1nus/CanoPaname" target="_blank" rel="noopener">le repo GitHub</a>
					si tu en croises un, sans garantie de réponse.
				</p>
			`,
		},
		{
			heading: '👶 Mineurs',
			bodyHtml: `
				<p>
					L'app ne demande pas d'âge et ne collecte rien — il n'y a
					donc pas de consentement parental à recueillir. Si l'app
					est utilisée par un mineur, l'app ne traite aucune donnée
					le concernant&nbsp;; les captures qu'il fait restent sur
					son appareil.
				</p>
			`,
		},
		{
			heading: '🔄 Changements',
			bodyHtml: `
				<p>
					Ces conditions peuvent être amendées au fil des versions.
					La date de dernière mise à jour figure en bas de la page.
					Les changements rétroactifs sur tes captures déjà faites
					ne sont jamais possibles&nbsp;: l'app ne peut pas y toucher
					depuis un serveur (elle n'a pas de serveur).
				</p>
			`,
		},
	],
	footerHtml: `
		<p class="info-footnote">
			Dernière mise à jour&nbsp;: 2026-05-10.
		</p>
	`,
}

export function mountTermsScreen(inRoot: HTMLElement): void
{
	mountInfoScreen(inRoot, kContent)
}
